import { ModalProps } from "@commonlibs";
import clsx from "clsx";
import { CardModalRoot } from "./CardModal.styles";

export interface CardModalProps extends ModalProps {
    /**
     * Modal will be full screen
     */
    fullScreen?: boolean;
}

function CardModal({ className, fullScreen, ...rest }: CardModalProps) {
    return <CardModalRoot className={clsx("card-modal", className, { fullScreen })} {...rest} />;
}

export default CardModal;
